import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArSiteSetupFormLockAccessAddedCancelNotifyAuthorProps extends BaseTemplateProps {
  request: {
    name: string
  }
}

export const ArSiteSetupFormLockAccessAddedCancelNotifyAuthor: TemplateDefinition<ArSiteSetupFormLockAccessAddedCancelNotifyAuthorProps> =
  {
    renderParams: (props: ArSiteSetupFormLockAccessAddedCancelNotifyAuthorProps) => ({
      messageKey: 'notificationsDomain.templates.arSiteSetupFormLockAccessAddedCancelNotifyAuthor',
      values: {
        siteName: props?.request?.name,
      },
    }),
    getLink: (props: ArSiteSetupFormLockAccessAddedCancelNotifyAuthorProps): string => {
      if (!props) return ''
      return '/app/admin/approvals-management/approval-requests-search?tool=site_setup_form_lock_access'
    },
  }
